import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Parameters } from '../type/parameters.type';
import { ParametersResponse } from '../type/parameters_response.type';
import { Filters } from '../type/filter.type';


@Injectable({
  providedIn: 'root'
})
export class ParametersService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}`;



  getParameters(): Observable<Parameters[] | null> {
    return this.http.get<ParametersResponse[]>(`${this.apiUrl}/analyze-parameters`)
      .pipe(map(this.mapParametersResponsesToParameters));
  }

  sendParameters(parameters: Parameters[]): Observable<Parameters[]> {
    return this.http
      .post<ParametersResponse[]>(`${this.apiUrl}/analyze-parameters`, parameters)
      .pipe(map(this.mapParametersResponsesToParameters));
  }

  getJsonFile(field: string): Observable<{ [key: string]: string[] }> {
    return this.http.get<{ [key: string]: string[] }>(`${this.apiUrl}/adls/${field}`);
  }


  sendFilter(field: Filters): Observable<[Filters]> {
    return this.http
      .post<[Filters]>(`${this.apiUrl}/adls/send-filters`, field);
  }


  private mapParametersResponsesToParameters(parametersResponse: ParametersResponse[] | null | undefined): Parameters[] {
    if (!Array.isArray(parametersResponse)) {
      return [];
    }
    return parametersResponse.map((params) => ({
      lever: {
        uuidFilters: params.uuidFilters,
        levers_title: params.levers_title,
        user_id: params.user_id,
        measure_file_id: params.measure_file_id,
        analyze_file_id: params.analyze_file_id,
        b100: params.lever_b100,
        hvo: params.lever_hvo,
        electric: params.lever_electric,
        biogas: params.lever_biogas,
        modalShift: params.lever_modal_shift,
        optimization: params.lever_optimization,
        deliveryFrequency: params.lever_delivery_frequency,
        loadingRate: params.lever_loading_rate,
        b100_value: params.lever_b100_value,
        hvo_value: params.lever_hvo_value,
        electric_value: params.lever_electric_value,
        biogas_value: params.lever_biogas_value,
        co2_value: params.co2_value || 0,
        budget_value: params.budget_value || 0
      },
      fuelPrice: {
        diesel: params.price_diesel,
        hvo: params.price_hvo,
        b100: params.price_b100,
        biogas: params.price_biogas,
        electric: params.price_electric
      },
      status: params.status,
      date: params.created_at
    }));
  }
}
